import { Building2, ExternalLink } from 'lucide-react';
import { CLIENT_PROFILE } from './customer/mockCustomerPortalData';
import DeliveryTracker from './customer/DeliveryTracker';
import BillingLedger from './customer/BillingLedger';
import RequestPanel from './customer/RequestPanel';

const P = {
  silver: '#F1F5F9',
  white: '#FFFFFF',
  grid: '#E2E8F0',
  blue: '#3B82F6',
  blueTint: '#EFF6FF',
  btnBlue: '#BFDBFE',
  btnBlueBorder: '#93C5FD',
  text: '#1E293B',
  muted: '#64748B',
};


const lightCard = {
  backgroundColor: P.white,
  borderColor: P.grid,
};

export default function CustomerPortal() {
  return (
    <>
      <header
        className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border px-5 py-4 shadow-sm"
        style={{ ...lightCard, borderWidth: 1, borderStyle: 'solid' }}
      >
        <div className="flex items-center gap-4">
          <div
            className="flex h-12 w-12 items-center justify-center rounded-xl shadow-sm"
            style={{ backgroundColor: P.blueTint, boxShadow: `inset 0 0 0 1px ${P.grid}` }}
          >
            <Building2 className="h-6 w-6" style={{ color: P.blue }} strokeWidth={1.75} />
          </div>
          <div>
            <p
              className="text-[10px] font-bold uppercase tracking-widest"
              style={{ color: P.blue }}
            >
              OGTS LogiCore™ · B2B Client Portal
            </p>
            <h1 className="text-xl font-bold text-black">{CLIENT_PROFILE.companyName}</h1>
            <p className="text-xs text-black/70">
              {CLIENT_PROFILE.shortCode} · Account {CLIENT_PROFILE.accountId} ·{' '}
              <span className="font-semibold text-black">{CLIENT_PROFILE.portalTier}</span>
            </p>
          </div>
        </div>
        <a
          href="#support"
          className="inline-flex items-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-bold text-black transition hover:opacity-90"
          style={{
            backgroundColor: P.btnBlue,
            borderColor: P.btnBlueBorder,
            borderWidth: 1,
            borderStyle: 'solid',
          }}
        >
          Contact Account Manager
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </header>

      <div className="space-y-6">
        <RequestPanel />
        <DeliveryTracker />
        <BillingLedger />
      </div>

      <footer
        className="mt-8 border-t pt-4 text-center text-xs text-black/60"
        style={{ borderColor: P.grid, borderTopWidth: 1, borderTopStyle: 'solid' }}
      >
        OGTS LogiCore™ Customer Portal · Secure B2B Self-Service · UAE Oil &amp; Gas Logistics
      </footer>
    </>
  );
}
